import { gql } from '@apollo/client';

export const CREATE_SESSION = gql`
    mutation createSession( $input: CreateSessionInput! ) {
        createSession( input: $input ) {
            id 
            instructorLedTrainingId
            locales {
                locale
                name
            }
            instructors {
                id
            }
            completionCodes {
                id
            } 
            address {
                id
            } 
            status
            maxSeats 
            meetingUrl
            filledSeats
            registrationUrl
            registrationOpenAt
            registrationCloseAt
            sessionStartAt
            sessionEndAt
            createdAt
            timezone
            updatedAt
            canceledAt
        }
    }
`;

export default CREATE_SESSION;
